import { Component, signal } from '@angular/core';
import { FooterComponent } from "../../../layouts/footer/footer.component";
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NgIf } from '@angular/common';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { CustomValidators } from 'src/app/validators/custom-validators';

@Component({
  selector: 'app-reset-password',
  imports: [FooterComponent, ReactiveFormsModule, NgIf, RouterLink],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.css'
})
export class ResetPasswordComponent {
  form!: FormGroup;
  public isLoading = signal<boolean>(false);
  public showPassword = signal(false);

  constructor(private fb: FormBuilder, private router: Router,
    private auth: AuthService,
    private route: ActivatedRoute,
    private _toastrService: ToastrService
  ) {}

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm() {
    const userId = this.route.snapshot.queryParams['userId'] || '';
    const token = this.route.snapshot.queryParams['token'] || '';
    
    if (!userId || !token) {
      this.router.navigate(['/Login']);
    }

    this.form = new FormGroup({
      userId: new FormControl(userId, [Validators.required]),
      token: new FormControl(token, [Validators.required]),
      newPassword: new FormControl(null, [
        Validators.required,
        Validators.minLength(6),
        CustomValidators.pattern(/[A-Z]/, 'requireUppercase', 'La contraseña debe incluir al menos una letra mayúscula.'),
        CustomValidators.pattern(/[a-z]/, 'requireLowercase', 'La contraseña debe incluir al menos una letra minúscula.'),
        CustomValidators.pattern(/[0-9]/, 'requireDigit', 'La contraseña debe incluir al menos un número.')
      ]),
      confirmPassword: new FormControl(null, [
        Validators.required
      ])
    }, { validators: CustomValidators.match('newPassword', 'confirmPassword', 'Las contraseñas no coinciden') });
  }

  submit() {
    if (this.form.invalid || this.form.get('newPassword')?.value !== this.form.get('confirmPassword')?.value) {
      this._toastrService.error('Las contraseñas no coinciden');
      return;
    }

    this.isLoading.set(true);

    this.auth.forgotPassword({
      userId: this.form.get('userId')?.value,
      token: this.form.get('token')?.value,
      password: this.form.get('newPassword')?.value,
    })
    .subscribe({
      next: res => {
        this.isLoading.set(false);
        if (res?.errors?.length > 0) {
          this._toastrService.error(res.errors[0]);
          return;
        }
        this._toastrService.success('','Su contraseña ha sido cambiada con éxito');
        this.router.navigate(['/login'])
      }, error: errors => {
        this.isLoading.set(false);
        this._toastrService.error(errors[0]);
      }
    });
  }
}